export const GRAPH_SCHEMA = [1, 1, 0]
export const graphSchemaString = (): string => {
    return `${GRAPH_SCHEMA[0]}.${GRAPH_SCHEMA[1]}.${GRAPH_SCHEMA[2]}`
}
